// extracted by mini-css-extract-plugin
export var tipFooterContainer = "tip-footer-module--tip-footer-container--IQ9kx";
export var tipFooterPersona = "tip-footer-module--tip-footer-persona--Hd6Iq";
export var tipFooterContact = "tip-footer-module--tip-footer-contact--YJpAv";
export var closingTextContainer = "tip-footer-module--closing-text-container--0KQ4o";
export var closingTextItem = "tip-footer-module--closing-text-item--jv34W";